import React from "react";
import { useWhoAmI } from "../../../user/useWhoAmI";
import ApplyWithProfile from "../../../business-components/apply/ApplyWithProfile";
import ApplyWithoutProfile from "../../../business-components/apply/ApplyWithoutProfile";

export default () => {
  const { confirmedHasProfileInConcern } = useWhoAmI();

  if (confirmedHasProfileInConcern) {
    return <ApplyWithProfile />;
  }

  return <ApplyWithoutProfile />;
};
